import type { OnboardingInfo, SaveData } from '@/domains/onboarding/types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { OnboardingApiService } from '../onboarding-api';

@injectable()
export class OnboardingApiServiceImpl extends PsHttpService implements OnboardingApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    save(data: SaveData) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/air-onboarding',
            data: {
                nickname: data.nickname,
                first_name: data.first_name,
                role: data.role,
                industry: data.industry,
                ...(data.product ? { product: data.product } : {}),
            },
        }).then((res) => {
            return res.status as boolean
        })
    }

    info() {
        return this.get<PatSnapCommonResponseData<OnboardingInfo>>({
            url: '/air-onboarding-info',
        }).then((res) => {
            return res.data as unknown as OnboardingInfo
        })
    }
}
